// store/archiveShow/actions/findArchive.ts
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Archive } from "../../../@types/archive";

const findArchive = createAsyncThunk<Archive, number | string, { rejectValue: any }>(
  "archiveShow/findArchive",
  async (id, { rejectWithValue }) => {
    try {
      const url = new URL(`${api.baseURL}archive/${id}`); // ajusta a .../meta si tu back entrega blob
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");
      headers.append("Accept", "application/json");

      const response = await fetch(url.toString(), { method: "GET", headers });
      if (!response.ok) {
        throw response.statusText;
      }

      // Debe venir: { id, filename, extension, path }
      const data = (await response.json()) as Archive;
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export default findArchive;
